import { BindAll } from 'lodash-decorators'

import { observable, action } from 'mobx'

import {
  getOrderStatsByCustomers,
  getVendorCompanies,
  getVendorCompany,
  updateVendorCompany,
  VendorCompanies,
  VendorCompany,
  UpdateVendorCompany,
  OrderStats,
} from 'vendor/server/vendor_companies'

@BindAll()
export default class VendorCompanyStore {
  @observable orderStats: OrderStats = {}

  vendorCompanies = observable.array<VendorCompanies>([])
  @observable selectedVendorCompany: Nullable<VendorCompany> = null

  @action
  async getOrderStatsByCustomers() {
    const { data } = await getOrderStatsByCustomers()
    this.orderStats = data?.order_stats
  }

  @action
  async getVendorCompanies() {
    const { data } = await getVendorCompanies()
    this.vendorCompanies.replace(data?.vendor_companies)
  }

  @action
  async getVendorCompany(id: string) {
    const { data } = await getVendorCompany(id)
    this.selectedVendorCompany = data?.vendor_company
  }

  updateVendorCompany(payload: UpdateVendorCompany) {
    return updateVendorCompany(payload)
  }
}
